import { apicall } from "../../services/api";
import { Toastify } from "../../services/toastify/toastifyContainer";
import {
	ALL_CLIENTS,
	CLIENT,
	CREATE_CLIENT,
	UPDATE_CLIENT,
	REMOVE_CLIENT,
	ERR_CLIENTS,
} from "./actionTypes";
import { setAlert } from "./alert.actions";
import http from "../../services/baseUrl";
import { toast } from "react-toastify";

export const getAllClients = () => async (dispatch) => {
	try {
		const res = await apicall(`api/v1/clients/`, "get");
		dispatch({
			type: ALL_CLIENTS,
			payload: res.data,
		});
	} catch (err) {
		dispatch({
			type: ERR_CLIENTS,
			payload: { msg: err.response.statusText, status: err.response.status },
		});
		dispatch(setAlert("Unable to fetch data", "error"));
	}
};

export const getClient = (clientId) => async (dispatch) => {
	try {
		const res = await apicall(`api/v1/clients/${clientId}`, "get");

		dispatch({
			type: CLIENT,
			payload: res.data,
		});
	} catch (err) {
		dispatch({
			type: ERR_CLIENTS,
			payload: { msg: err.response.statusText, status: err.response.status },
		});
		dispatch(setAlert("Unable to fetch data", "error"));
	}
};

export const createClient = (data) => async (dispatch) => {
	try {
		const res = await apicall("api/v1/clients/", "post", data);
		dispatch({
			type: CREATE_CLIENT,
			payload: res.data,
		});

		dispatch(getAllClients());
		toast.success(res.data.message);
	} catch (err) {
		dispatch({
			type: ERR_CLIENTS,
			payload: { msg: err.response.statusText, status: err.response.status },
		});
		toast.error(err.response.data.msg);
	}
};

export const updateClient = (clientId, formData) => async (dispatch) => {
	try {
		const res = await apicall(`api/v1/clients/${clientId}`, "patch", formData, {
			headers: {
				"Content-Type": "multipart/form-data",
				"Access-Control-Allow-Origin": "*",
			},
		});
		dispatch({
			type: UPDATE_CLIENT,
			payload: res.data.data,
		});
		toast.success(res.data.message);
	} catch (err) {
		dispatch({
			type: ERR_CLIENTS,
			payload: { msg: err.response.statusText, status: err.response.status },
		});
		toast.error(err.response.data.msg);
	}
};

export const updateStatus = (clientId, data) => async (dispatch) => {
	try {
		const res = await apicall(`api/v1/clients/status/${clientId}?status=${data}`, "patch");
		dispatch(setAlert(res.data.message, "success"));
		return res;
	} catch (err) {
		dispatch({
			type: ERR_CLIENTS,
			payload: { msg: err.response.statusText, status: err.response.status },
		});
		dispatch(setAlert("Unable to update client", "error"));
	}
};

export const deleteClient = (clientId) => async (dispatch) => {

	try {
		const res = await apicall(`api/v1/clients/${clientId}`, "delete");
		dispatch({ type: REMOVE_CLIENT, payload: clientId });
		dispatch(setAlert("Client deleted successfully", "success"));
		toast.success(res.data.message);
		return res
	} catch (err) {
		dispatch({
			type: ERR_CLIENTS,
			payload: { msg: err.response.statusText, status: err.response.status },
		});
		toast.error(err.response.data.msg);
	}
};


export const uploadClientImg = (image) => async () => {

	try {
		const res = await http.post("api/v1/clients/uploadImage", image, {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		});
		Toastify({ data: "success", msg: res?.data?.message });
		return res?.data?.data;
	} catch (err) {
		console.log(err);
		Toastify({ data: "error", msg: err?.response?.data?.message });
	}
}
